module.exports = __webpack_public_path__ + "static/media/boston.ee9eb568.png";